import { useTranslation } from 'react-i18next';

import BrokerSelector from './sections/BrokerSelector/BrokerSelector';
import HelpButton from './sections/HelpButton/HelpButton';
import NavItem from './sections/NavItem/NavItem';
import SidebarHeader from './sections/SidebarHeader/SidebarHeader';
import SidebarUserProfile from './sections/SidebarUserProfile/SidebarUserProfile';
import { NAV_ITEMS } from '../../../constants/navigation';
import { useAuth } from '../../../hooks/useAuth/useAuth';
import { useUser } from '../../../hooks/useUser/useUser';
import { ISidebarProps } from '../../../interfaces/globals';
import { getInitialsFromName, getInitialsFromEmail } from '../../../utils/utils';
import './Sidebar.scss';

const Sidebar = ({ collapsed, onToggle }: ISidebarProps) => {
  const { email, sessionLogout } = useAuth();
  const { userInfo } = useUser();
  const { t } = useTranslation();

  const displayName = userInfo ? `${userInfo.name} ${userInfo.lastName ?? ''}`.trim() : email;

  const initials = userInfo ? getInitialsFromName(userInfo.name, userInfo.lastName) : getInitialsFromEmail(email);

  return (
    <aside className={`sidebar${collapsed ? ' sidebar--collapsed' : ''}`}>
      <SidebarHeader collapsed={collapsed} onToggle={onToggle} />

      <nav className="sidebar__nav">
        {NAV_ITEMS.map(({ id, to, label, Icon, disabled }) => (
          <NavItem
            key={id}
            to={to}
            label={t(label)}
            icon={<Icon />}
            collapsed={collapsed}
            disabled={disabled}
            sectionId={id}
          />
        ))}
      </nav>

      <BrokerSelector collapsed={collapsed} />

      <div className="sidebar__help">
        <HelpButton collapsed={collapsed} />
      </div>

      <SidebarUserProfile
        initials={initials}
        displayName={displayName}
        role="Broker"
        collapsed={collapsed}
        onProfileClick={sessionLogout}
      />
    </aside>
  );
};

export default Sidebar;
